module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.label))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path,
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.meta.label) + "\n      ")])
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a9cc5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/Levelbar.vue
// module id = 645
// module chunks = 25